@if (isLoading()) {
  <div class="bg-amber-50 border border-outline-brown flex flex-col overflow-hidden rounded-lg shadow-module h-full">
    <div class="flex items-center justify-between p-3 border-b border-outline-brown">
      <p-skeleton width="8rem" height="1.75rem"></p-skeleton>
    </div>
    <div class="flex-1 overflow-y-auto p-2">
      <div class="border-b border-outline-brown">
        <div class="bg-surface-50 px-4 py-3 flex items-center justify-between">
          <p-skeleton width="8rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
        <div class="p-4 flex flex-col gap-4">
          @for (i of [1, 2, 3]; track i) {
            <div>
              <p-skeleton width="6rem" height="0.875rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
            </div>
          }
          <div>
            <p-skeleton width="8rem" height="0.875rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100%" height="5rem" borderRadius="0.375rem"></p-skeleton>
          </div>
          <p-skeleton width="100%" height="2.5rem" borderRadius="1.5rem"></p-skeleton>
        </div>
      </div>
      <div class="border-b border-outline-brown">
        <div class="bg-surface-50 px-4 py-3 flex items-center justify-between">
          <p-skeleton width="12rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
      </div>
      <div>
        <div class="bg-surface-50 px-4 py-3 flex items-center justify-between">
          <p-skeleton width="10rem" height="1.25rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div
    [class]="
      isMobile()
        ? 'bg-amber-50 flex flex-col h-full overflow-hidden'
        : 'bg-amber-50 border border-outline-brown flex flex-col rounded-lg shadow-module  h-full overflow-hidden'
    "
  >
    <div class="flex items-center justify-between px-4 py-[18px] border-b border-outline-brown rounded-t-lg z-10 mb-2">
      <div class="flex items-center gap-2">
        <!-- The option's own description when it has one, then the next name it carries:
             sales description, then product code. The literal is the last resort, for a
             product that failed to load and so has no name at all. -->
        <h2 class="text-primary-500 text-body-700 m-0">
          {{ product().productCode }}
        </h2>
        <!-- @if (product().productTypeName) {
          <span
            class="inline-flex items-center px-2 py-0.5 text-body-2xs border border-outline-brown text-surface-500 rounded-xs"
          >
            {{ product().productTypeName }}
          </span>
        } -->
      </div>
      <button
        type="button"
        class="md:!hidden p-1 -mr-1 flex items-center justify-center text-surface-400 hover:text-surface-700 bg-transparent border-none cursor-pointer"
        (click)="onClose.emit()"
      >
        <i class="pi pi-times text-base"></i>
      </button>
    </div>

    <div class="flex-1 min-h-0 px-2 pb-2 overflow-y-auto">
      <p-accordion [multiple]="true" [value]="['0', '1', '2']" class="options-sidebar">
        <p-accordion-panel value="0">
          <div class="selected-product-panel rounded-md overflow-hidden">
            <p-accordion-header class="py-3 px-2">
              <div class="flex items-center gap-2">
                <h6 class="text-body-600 text-surface-700 m-0">Basic Details</h6>
                <dsm-changes-saved [savedAt]="basicDetailsForm.savedVisible()" />
              </div>
            </p-accordion-header>
            <p-accordion-content class="block m-0">
              <div class="px-2 pb-3 pt-0">
                <dsm-aps-addendum-option-basic-details-form
                  #basicDetailsForm
                  [dealAddendum]="dealAddendum()"
                  [addendumOption]="product()!"
                  [isKitLinkedProduct]="isKitLinkedProduct()"
                  (onChanges)="onBasicDetailsChanges()"
                  [isCancelled]="dealAddendum().isCancelled"
                />
              </div>
            </p-accordion-content>
          </div>
        </p-accordion-panel>

        @if (!isKitLinkedProduct()) {
          <p-accordion-panel value="1">
            <div class="selected-product-panel rounded-md overflow-hidden">
              <p-accordion-header class="py-3 px-2">
                <div class="flex items-center gap-2">
                  <h6 class="text-body-600 text-surface-700 m-0">Pricing &amp; Discounts</h6>
                  <dsm-changes-saved [savedAt]="pricingDiscountForm.savedVisible()" />
                </div>
              </p-accordion-header>
              <p-accordion-content class="block">
                <div class="px-2 pb-3 pt-0">
                  <dsm-deal-pricing-discount
                    #pricingDiscountForm
                    [buyerAndBuilderApproved]="dealAddendum().isLocked"
                    [addendumOption]="product()!"
                    (discountUpdated)="onTaxInformationChanges()"
                    [isCancelled]="dealAddendum().isCancelled"
                  />
                </div>
              </p-accordion-content>
            </div>
          </p-accordion-panel>

          <p-accordion-panel value="2">
            <div class="selected-product-panel rounded-md overflow-hidden">
              <p-accordion-header class="py-3 px-2">
                <div class="flex items-center gap-2">
                  <h6 class="text-body-600 text-surface-700 m-0">Tax Information</h6>
                  <dsm-changes-saved [savedAt]="taxInfoForm.savedVisible()" />
                </div>
              </p-accordion-header>
              <p-accordion-content class="block">
                <div class="px-2 pb-3 pt-0">
                  <dsm-deal-tax-information
                    #taxInfoForm
                    [buyerAndBuilderApproved]="dealAddendum().isLocked"
                    [addendumProductId]="addendumProductId()"
                    [addendumProductTaxes]="product().taxes"
                    [category]="product().taxCategory"
                    (reload)="onTaxInformationChanges()"
                  ></dsm-deal-tax-information>
                </div>
              </p-accordion-content>
            </div>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </div>
}
